import { useState, useEffect } from 'react';
import { PricingPlans } from './PricingPlans';
import { checkPromotionAvailability } from '../services/api';

const SubscriptionModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [showPromoBanner, setShowPromoBanner] = useState(false);


  useEffect(() => {
    const storedPremiumUntil = localStorage.getItem('premiumUntil');

    if (!storedPremiumUntil || storedPremiumUntil == 'null' || storedPremiumUntil == undefined) {
      setShowModal(true);
      return;
    }

    const expiryDate = new Date(storedPremiumUntil);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (expiryDate < today) {
      setShowModal(true);
    }
  }, []);


  useEffect(() => {
    // Check if promotion is available
    const checkPromotion = async () => {
      try {
        const res = await checkPromotionAvailability();
        setShowPromoBanner(!res.is_offer_claimed);
      } catch (error) {
        console.error('Error checking promotion availability:', error);
        setShowPromoBanner(false);
      }
    };

    if (showModal) {
      checkPromotion();
    }
  }, [showModal]);

  const handleSuccess = () => {
    // Close modal and optionally redirect
    setShowModal(false);
    // You can add additional success handling here
  };

  if (!showModal) return null;

  // Get user info from localStorage
  const userInfo = {
    id: localStorage.getItem('user_id') || '',
    email: localStorage.getItem('email') || '',
    name: localStorage.getItem('name') || 'User'
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-gray-800 p-6 max-w-6xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="mb-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-2">Renew your subscription</h2>
          <p className="text-white/80">Choose your plan to continue using the app</p>
        </div>

        {/* Promotional Banner */}
        {showPromoBanner && (
          <div className="mb-6 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg p-4 text-center">
            <h3 className="text-xl font-semibold text-white mb-2">
              🎉 Special Offer: Get 1 Month Free! 🎉
            </h3>
            <p className="text-white/90 mb-3">
              Post us on your Instagram or X and get a month's subscription free!
            </p>
            <p className="text-white/70 text-sm">
              <button
                onClick={() => window.location.href = '/free-subscription'}
                className="bg-white hover:text-white transition-colors" style={{ color: '#2563eb' }}
              >
                Know how
              </button>
            </p>
          </div>
        )}

        <PricingPlans
          userInfo={userInfo}
          onSuccess={handleSuccess}
        />

      </div>
    </div>
  );
};

export default SubscriptionModal;